export default (path, opts={})=>{
	if( path[0] != '/' ) path = '/'+path
	return fetch(APP_API_PATH+path, opts)
	.then(r=>r.json())
}